import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { ErrorHelper } from '../../../shared/helpers/error.helper';
import { MessageHelper } from '../../../shared/helpers/message.helper';
import { AuthService } from '../../../shared/services/auth.service';
import { SidenavComponent } from '../../sidenav.component';
import { Router } from '@angular/router';
import { AuthStateService } from '../../services/auth-state.service';

@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss'],
})
export class MfaComponent implements OnInit {
  formGroup?: FormGroup;

  requestingAccess: boolean = false;

  countdown: number = 0;
  isResendDisabled: boolean = false;
  private timerInterval: any;

  @Input() sidenav?: SidenavComponent;

  constructor(
    private auth: AuthService,
    private formBuilder: FormBuilder,
    private router: Router,
    private errorHelper: ErrorHelper,
    private authState: AuthStateService
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.startResendTimer();
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      code: [null, [Validators.required, Validators.minLength(6)]],
    });
  }

  async resendCode() {
    const user = this.authState.getEmail();
    const password = this.authState.getPassword();

    await this.auth.login(user!, password!);

    this.startResendTimer();
  }

  async verifyMfa() {
    if (this.formGroup?.valid) {
      this.requestingAccess = true;

      try {
        const user = this.authState.getEmail();
        const { code } = this.formGroup?.value;
        await this.auth.verifyMfa(user ?? '', code);

        // Check for password change requirement
        if (this.auth.needChangePassword()) {
          this.sidenav?.forcePasswordChange();
          return;
        }

        const redirectUrl =
          localStorage.getItem('redirectUrlAfterLogin') || '/dashboard';
        localStorage.removeItem('redirectUrlAfterLogin');
        await this.sidenav?.controller?.close();
        this.router.navigateByUrl(redirectUrl);
      } catch (e) {
        this.errorHelper.catch(Error, {
          401: 'Code is invalid',
        });
      } finally {
        this.requestingAccess = false;
      }
    }
  }

  private startResendTimer(): void {
    this.countdown = 30; // segundos
    this.isResendDisabled = true;

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        this.isResendDisabled = false;
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  showFieldError(field: string) {
    const formField = this.formGroup?.get(field);
    return formField?.invalid && (formField.dirty || formField.touched);
  }

  async backToLogin() {
    await this.sidenav?.controller?.close();
    this.sidenav?.openSidenav('login');
  }
}
